<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container
    class="px-6 pt-0"
    style="position: relative"
  >
    <div
      class="d-flex align-center pt-3"
      style="position: sticky;top: 0;background:rgb(250, 251, 252);z-index: 4"
    >
      <back-button
        @close="close"
      />
      <template v-if="!loading">
        <page-header v-if="!isAdd">
          {{ $t('product_details') }} / {{ name }}
        </page-header>
        <page-header v-else>
          {{ $t('create_new_product') }} / {{ $route.params.consumeTypeName }}
        </page-header>
      </template>
      <template v-else>
        <page-header>{{ $t('load') }}</page-header>
      </template>
      <v-spacer/>
      <v-btn
        :disabled="!valid"
        :loading="loading"
        class="mr-2"
        color="green"
        elevation="0"
        @click="save"
      >
        {{ $t('save_change') }}
      </v-btn>
    </div>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div
        v-if="!loading"
        class="mt-4 pa-4 px-12"
      >
        <div
          v-if="imageField.length>0"
          class="mt-8"
        >
          <form-field
            :current-state="editedIndex"
            :edited-item="editedItem"
            :field="imageField[0]"
            no-details
          />
        </div>
        <v-card
          class="flex-grow-1 pa-4 px-6 mt-8"
          outlined
        >
          <template v-for="(field,index) in groupedFields">
            <div
              :key="field.value+index+'group'"
            >
              <div class="d-flex align-center">
                <div>
                  <div class="text-h4 font-weight-medium">
                    {{ $t('' + field.groupName) }}
                  </div>
                  <div class="text-caption">
                    {{ $t('other_lang_could_not_be_filled_if_not_fill_just_one_lang_can_be_used') }}
                  </div>
                </div>
                <v-spacer/>
                <div class="d-flex">
                  <div>
                    <v-tabs
                      v-model="langTab"
                      color="#232123"
                      height="36px"
                      style="background: transparent!important;"
                    >
                      <v-tab
                        v-for="(child,i) in field.children"
                        :key="field.value+'c'+editedItem[field.value][i][field.childLabelKey]+'tab'"
                      >
                        {{ $t(editedItem[field.value][i][field.childLabelKey].toLowerCase()) }}
                        <span
                          v-if="i===0"
                          class="red--text"
                        > * </span>
                      </v-tab>
                    </v-tabs>
                  </div>
                </div>
              </div>
              <v-tabs-items
                v-model="langTab"
                class="mt-4"
              >
                <v-tab-item
                  v-for="(child,i) in field.children"
                  :key="i+'dishId'"
                >
                  <template v-for="(c,t) in child">
                    <div :key="field.id+'t'+t+'c'+i">
                      <form-field
                        v-if="editedItem[field.value]"
                        :current-state="editedIndex"
                        :edited-item="editedItem[field.value][i]"
                        :field="c"
                        no-details
                      />
                    </div>
                  </template>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </template>
          <div>
            <template v-for="(field,index) in requiredFields">
              <div
                v-if="isRefreshCategory"
                :key="'f1'+index+field.text"
              >
                <form-field
                  :current-state="editedIndex"
                  :edited-item="editedItem"
                  :field="field"
                  no-details
                  @click="addNew(-1)"
                />
              </div>
            </template>
          </div>
        </v-card>

        <attribute-edit-fragment
          :dishes-id="id"
          @update-mod-list="e=>editedItem.attributeGroupId=e"
        />

        <v-card
          v-if="notRequiredFields.length>0"
          class="pa-4 px-6 mt-8"
          height="fit-content"
          outlined
        >
          <div class="d-flex  mt-2 ">
            <div class="text-h4 font-weight-medium">
              {{ $t('option_info') }}
            </div>
            <v-spacer/>
            <v-btn
              icon
              outlined
              style="border-radius: 8px"
              @click="showOptionalField=!showOptionalField"
            >
              <v-icon v-if="!showOptionalField">
                mdi-chevron-down
              </v-icon>
              <v-icon v-else>
                mdi-chevron-up
              </v-icon>
            </v-btn>
          </div>
          <div
            v-if="showOptionalField"
            class="mt-6"
          >
            <template v-for="(field,index) in notRequiredFields">
              <div
                v-if="isRefreshAllergen"
                :key="'f2'+index"
                class="my-4"
              >
                <form-field
                  :current-state="editedIndex"
                  :edited-item="editedItem"
                  :field="field"
                  no-details
                  @click="addNewAllergen(-1)"
                />
              </div>
            </template>
            <div class="my-4">
              <div class="text-caption pb-1">
                {{ $t('dishesShowThisMenu') }}
              </div>
              <v-select
                v-model="selectedShowThisMenu"
                :items="consumeTypeList"
                :menu-props="{offsetY:true, outlined:true,
                              contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                :placeholder="$t('chooseMenu')"
                item-text="name"
                item-value="id"
                multiple
                outlined
                return-object
              />
            </div>
            <div class="my-4">
              <div class="text-caption pb-1">
                {{ $t('dishesFreeThisMenu') }}
              </div>
              <v-select
                v-model="selectedFreeMenu"
                :items="consumeTypeList"
                :menu-props="{offsetY:true, outlined:true, contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                :placeholder="$t('dishesFreeThisMenu')"
                item-text="name"
                item-value="id"
                multiple
                outlined
                return-object
              />
            </div>
          </div>
          <div
            v-else
            class="mt-4 text-body-2"
          >
            {{ $t('notRequired') }}<br><br>
            <template v-for="(field,index) in notRequiredFields">
              <v-chip
                :key="'f2'+index"
                class="text-body-1 font-weight-bold mb-1 mr-1"
                label
                outlined
                @click="showOptionalField=true"
              >
                {{ $t(field.text) }}
                <template v-if="editedItem[field.value]&&field.dataType!==IKDataEntity.Types.Color">
                  : {{
                    Array.isArray(editedItem[field.value]) ? editedItem[field.value].length + $t('个') : editedItem[field.value]
                  }}
                </template>
              </v-chip>
            </template>
          </div>
        </v-card>
      </div>
    </v-form>

    <ik-entity-form
      v-model="showCategoryDialog"
      :edited-index="activeCategoryIndex"
      :model="categoryModel"
      @need-refresh="loadCategory"
    />
    <ik-entity-form
      v-model="showAllergenDialog"
      :edited-index="activeAllergenIndex"
      :model="AllergenModel"
      @need-refresh="loadAllergen"
    />
  </v-container>
</template>

<script>
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import BackButton from '@/composable/InK/BackButton'
  import Dish from '@/model/dish/Dish'
  import { IKDataEntity, IkEntityForm } from 'metaflow-js'
  import FormField from 'metaflow-js/EntityFrameWork/VueTemplate/FormField'
  import IKUtils from 'innerken-js-utils'
  import Category from '@/model/dish/Category'
  import Allergen from '@/model/dish/Allergen'
  import ConsumeType from '@/model/buffet/ConsumeType'
  import DishesConsumeType from '@/model/buffet/DishesConsumeType'
  import { keyBy } from 'lodash'
  import { copyToAll, showSuccessMessage } from '@/common/utils'
  import AttributeEditFragment from '@/views/AadenPages/dishes/dish/detail/fragments/AttributeEditFragment'

  export default {
    name: 'DishesDetail',
    components: {
      AttributeEditFragment,
      IkEntityForm,
      FormField,
      PageHeader,
      BackButton,
    },
    props: {
      id: {
        default: -1,
      },
    },
    data () {
      return {
        selectedFreeMenu: [],
        selectDishMenu: {},
        selectedShowThisMenu: [],
        menuList: [],
        consumeTypeDishList: null,
        consumeTypeList: [],
        AllergenModel: Allergen,
        activeAllergenIndex: null,
        showAllergenDialog: null,
        showCategoryDialog: null,
        activeCategoryIndex: null,
        categoryModel: Category,
        isRefreshCategory: true,
        isRefreshAllergen: true,
        loading: false,
        showOptionalField: false,
        langTab: null,
        model: Dish,
        editedIndex: -1,
        tab: 0,
        valid: true,
        formField: [],
        currentList: [],
        IKDataEntity: IKDataEntity,
        defaultItem: null,
        calculateDefaultItem: null,
        editedItem: null,
        keyStore: {},

      }
    },
    computed: {
      isAdd () {
        return parseInt(this.editedIndex) === -1
      },
      requiredFields: function () {
        return this.notGroupedFields.filter(f => this.fieldIsRequired(f))
      },
      notRequiredFields: function () {
        return this.notGroupedFields.filter(f => !this.fieldIsRequired(f))
      },
      groupedFields: function () {
        return this.notImageField.filter(f => f.dataType === IKDataEntity.Types.Group)
      },
      notGroupedFields: function () {
        return this.notImageField.filter(f => f.dataType !== IKDataEntity.Types.Group)
      },
      imageField: function () {
        return this.formField.filter(f => f.dataType === IKDataEntity.Types.Image)
      },
      uniqueField: function () {
        return this.formField.filter(f => f.unique)
      },
      notImageField: function () {
        return this.formField.filter(f => f.dataType !==
          IKDataEntity.Types.Image)
      },
      name () {
        return (this?.editedItem?.name ?? this.editedItem?.dishName ?? this.$t('load'))
      },
    },
    async mounted () {
      await this.wait(async () => {
        [, this.formField, this.calculateDefaultItem] = IKDataEntity.parseField(this.model)
        Object.freeze(this.calculateDefaultItem)
        await this.initialForm()
        this.consumeTypeList = (await ConsumeType.getList(true))
        for (const c of this.consumeTypeList) {
          this.selectDishMenu[c.id] =
            keyBy(await DishesConsumeType.getList(true, { consumeTypeId: c.id }), 'dishId')
          if (this.selectDishMenu[c.id][this.$route.params.id].showing === true) {
            this.selectedShowThisMenu.push(c)
          }
          if (this.selectDishMenu[c.id][this.$route.params.id].isFree === true) {
            this.selectedFreeMenu.push(c)
          }
        }
      })
      if (this.$route.params.id < 0) {
        if (this.$route.params.consumeTypeName.id === -1) {
          this.selectedShowThisMenu = this.consumeTypeList
          this.selectedFreeMenu = this.consumeTypeList
        } else {
          this.selectedShowThisMenu = Array.of(this.$route.params.consumeTypeName)
          this.selectedFreeMenu = Array.of(this.$route.params.consumeTypeName)
        }
      }
    },
    methods: {
      addNewAllergen (index) {
        this.showAllergenDialog = true
        this.activeAllergenIndex = index
      },
      async loadAllergen (item) {
        this.isRefreshAllergen = false
        this.editedItem.AllergenId.push(parseInt(item.content.id))
        await Allergen.getList(true)
        this.isRefreshAllergen = true
      },
      async loadCategory (item) {
        this.isRefreshCategory = false
        this.editedItem.categoryId = parseInt(item.content.id)
        await Category.getList(true)
        this.isRefreshCategory = true
      },
      async addNew (index) {
        this.showCategoryDialog = true
        this.activeCategoryIndex = index
      },

      async afterEdit () {
        this.loading = false
      },

      resetDefaultItem () {
        this.defaultItem = this.calculateDefaultItem
      },

      fieldIsRequired (field) {
        return field.required && (
          (field.requiredEdit && this.editedIndex !== -1) ||
          (field.requiredNew && this.editedIndex === -1))
      },

      async refreshList () {
        this.currentList = this.outSideList ?? await IKUtils.safeCallFunction(this.model, this.model.getList, true)
      },

      async initialForm () {
        await this.refreshList()
        this.editedIndex = this.currentList.findIndex(i => parseInt(i.id) === parseInt(this.id))
        if (this.editedIndex === -1) {
          this.resetDefaultItem()
          this.editedItem = IKUtils.deepCopy(this.defaultItem)
        } else {
          this.editedItem = IKUtils.deepCopy(this.currentList[this.editedIndex])
        }
        if (this.uniqueField.length > 0) {
          this.keyStore = {}
          this.keyStore = await this.uniqueField.reduce(async (obj, i) => {
            const trackingList = i.uniqueTrackingList ? await i.uniqueTrackingList() : this.currentList
            obj[i.value] = trackingList.map(it => it[i.value]).filter(it => it !== this.editedItem[i.value])
            return obj
          }, {})
          this.uniqueField.forEach(it => {
            it.rule = []
            if (this.keyStore[it.value]) {
              const uniqueCheck = val => (this.keyStore[it.value] && !this.keyStore[it.value].includes(val)) || this.$t(it.text) + this.$t('duplicated')
              it.rule.push(uniqueCheck)
            }
          })
        }
      },

      async wait (action) {
        this.loading = true
        try {
          await action()
        } catch (e) {

        }
        this.loading = false
      },

      async save (close = true) {
        for (const f of this.groupedFields) {
          copyToAll(f, this.editedItem[f.value])
        }
        if (!this.$refs.form.validate()) {
          return
        }
        await this.wait(async () => {
          if (this.editedIndex > -1) {
            await IKUtils.safeCallFunction(this.model, this.model.edit, this.editedItem)
            for (const d of this.consumeTypeList) {
              (await DishesConsumeType.edit({
                consumeTypeId: (d.id).toString(),
                dishId: this.$route.params.id,
                showing: false,
                isFree: false,
              }))
            }
            for (const x of this.selectedShowThisMenu) {
              (await DishesConsumeType.edit({
                consumeTypeId: (x.id).toString(),
                dishId: this.$route.params.id,
                showing: true,
              }))
            }
            for (const x of this.selectedFreeMenu) {
              (await DishesConsumeType.edit({
                consumeTypeId: (x.id).toString(),
                dishId: this.$route.params.id,
                isFree: true,
              }))
            }
            showSuccessMessage(this.$t('edit_success'))
            this.close(true)
          } else {
            const res = await this.model.add(this.editedItem)
            const isShowingArr = this.selectedShowThisMenu.map(it => it.id)
            const isFreeArr = this.selectedFreeMenu.map(it => it.id)
            for (const item of this.consumeTypeList) {
              (await DishesConsumeType.edit({
                consumeTypeId: (item.id).toString(),
                dishId: res.id,
                showing: isShowingArr.includes(item.id),
                isFree: isFreeArr.includes(item.id),
              }))
            }
            showSuccessMessage(this.$t('add_success'))
            if (close) {
              this.close(true)
            } else {
              await this.initialForm()
            }
          }
        })
      },

      close () {
        this.$router.back()
      },
    },
  }
</script>

<style>
.theme--light.v-tabs > .v-tabs-bar {
  background: transparent !important;
}

.theme--light.v-tabs-items {
  background: transparent !important;
}
</style>
